module.exports = __webpack_public_path__ + "media/newstyle/images/info2-217e5a57009127c32e52050077b31c92.jpg";